import React from 'react';

function PointUp({ color = 'text-shuttle-grey', size = 'w-3 h-3', className = '' }) {
	return (
		<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
			<g
				id="icon/monochrome/functions/navigation/point-up"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
				className={`${size} fill-current ${color} ${className}`}
			>
				<g className={`${size} fill-current ${color}`} id="export">
					<rect id="box" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16" />
					<path
						d="M3.25574396,11.7542913 C2.9719134,12.0381219 2.60253386,12.1987217 2.19872167,12.1987217 C1.79490948,12.1987217 1.42552995,12.0381219 1.14169939,11.7542913 L0.444430359,11.0570223 C0.160599797,10.7731917 0,10.4038122 0,10 C0,9.59618781 0.160599797,9.22680828 0.444430359,8.94297772 L6.94297772,2.44443036 C7.22680828,2.1605998 7.59618781,2 8,2 C8.40381219,2 8.77319172,2.1605998 9.05702228,2.44443036 L15.5555696,8.94297772 C15.8394002,9.22680828 16,9.59618781 16,10 C16,10.4038122 15.8394002,10.7731917 15.5555696,11.0570223 L14.8583006,11.7542913 C14.57447,12.0381219 14.2050905,12.1987217 13.8012783,12.1987217 C13.3974661,12.1987217 13.0280866,12.0381219 12.744256,11.7542913 L8,7.01003527 L3.25574396,11.7542913 Z"
						id="point-up"
					/>
				</g>
			</g>
		</svg>
	);
}

export default PointUp;
